import { Pipe, PipeTransform } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IImage } from '../../services/posts/posts.type';
import { ImagePreviewType } from '../../enums';

@Pipe({ name: 'getImagePreview', standalone: true })
export class GetImagePreviewPipe implements PipeTransform {
  transform(image: IImage | undefined, previewType: ImagePreviewType): string {
    if (!image) {
      return '';
    }

    let src = image.previewImages.find((img) => img.previewType === previewType)?.preview;

    if (!src) {
      src = image.previewImages.find((img) => img.previewType === ImagePreviewType.normal)?.preview;
    }

    if (!src) {
      src = image.path;
    }

    return src ? environment.befreeUrl + src : '';
  }
}
